import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Layout from '../components/Layout';
import Login from '../pages/Login';
import Employees from '../pages/admin/Employees';
import Profile from '../pages/employee/Profile';
import EmployeeAttendance from '../pages/employee/Attendance';
import EmployeeWFH from '../pages/employee/WFH';
import AdminAttendance from '../pages/admin/Attendance';
import EmployeeLeaves from '../pages/employee/Leaves';
import AdminLeaves from '../pages/admin/Leaves';
import AdminSettings from '../pages/admin/Settings';
import AdminPayroll from '../pages/admin/Payroll';
import EmployeePayslips from '../pages/employee/Payslips';
import TeamRequests from '../pages/employee/TeamRequests';
import EmployeeHolidays from '../pages/employee/Holidays';

const ProtectedRoute = ({ children, roles, preventRemote }) => {
  const { user } = useContext(AuthContext);
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles) {
    let hasAccess = roles.includes(user.role);
    if (roles.includes('Manager') && user.isManager) {
      hasAccess = true;
    }
    if (!hasAccess) {
      return <Navigate to="/" replace />;
    }
  }

  if (preventRemote && user.workLocation === 'WFH') {
    return <Navigate to="/" replace />;
  }

  return <Layout>{children}</Layout>;
};

const DashboardRedirect = () => {
  const { user } = useContext(AuthContext);
  
  if (!user) return <Navigate to="/login" replace />;
  
  switch(user.role) {
    case 'Super Admin': return <Navigate to="/superadmin/employees" replace />;
    case 'Admin': return <Navigate to="/admin/employees" replace />;
    case 'HR': return <Navigate to="/hr/employees" replace />;
    default: return <Navigate to="/employee/profile" replace />;
  }
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<DashboardRedirect />} />
        
        {/* Super Admin Routes */}
        <Route path="/superadmin/employees" element={<ProtectedRoute roles={['Super Admin']}><Employees /></ProtectedRoute>} />
        <Route path="/superadmin/attendance" element={<ProtectedRoute roles={['Super Admin']}><AdminAttendance /></ProtectedRoute>} />
        <Route path="/superadmin/leaves" element={<ProtectedRoute roles={['Super Admin']}><AdminLeaves /></ProtectedRoute>} />
        <Route path="/superadmin/settings" element={<ProtectedRoute roles={['Super Admin']}><AdminSettings /></ProtectedRoute>} />
        <Route path="/superadmin/payroll" element={<ProtectedRoute roles={['Super Admin']}><AdminPayroll /></ProtectedRoute>} />
        
        {/* Admin Routes */}
        <Route path="/admin/employees" element={<ProtectedRoute roles={['Super Admin', 'Admin']}><Employees /></ProtectedRoute>} />
        <Route path="/admin/attendance" element={<ProtectedRoute roles={['Super Admin', 'Admin']}><AdminAttendance /></ProtectedRoute>} />
        <Route path="/admin/leaves" element={<ProtectedRoute roles={['Super Admin', 'Admin']}><AdminLeaves /></ProtectedRoute>} />
        <Route path="/admin/payroll" element={<ProtectedRoute roles={['Super Admin', 'Admin']}><AdminPayroll /></ProtectedRoute>} />
        
        {/* HR Routes */}
        <Route path="/hr/employees" element={<ProtectedRoute roles={['Super Admin', 'Admin', 'HR']}><Employees /></ProtectedRoute>} />
        <Route path="/hr/attendance" element={<ProtectedRoute roles={['Super Admin', 'Admin', 'HR']}><AdminAttendance /></ProtectedRoute>} />
        <Route path="/hr/leaves" element={<ProtectedRoute roles={['Super Admin', 'Admin', 'HR']}><AdminLeaves /></ProtectedRoute>} />
        <Route path="/hr/payroll" element={<ProtectedRoute roles={['Super Admin', 'Admin', 'HR']}><AdminPayroll /></ProtectedRoute>} />
        <Route path="/hr/settings" element={<ProtectedRoute roles={['Super Admin', 'HR']}><AdminSettings /></ProtectedRoute>} />
        
        {/* Employee Routes */}
        <Route path="/employee/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/employee/attendance" element={<ProtectedRoute><EmployeeAttendance /></ProtectedRoute>} />
        <Route path="/employee/wfh" element={<ProtectedRoute preventRemote><EmployeeWFH /></ProtectedRoute>} />
        <Route path="/employee/leaves" element={<ProtectedRoute><EmployeeLeaves /></ProtectedRoute>} />
        <Route path="/employee/holidays" element={<ProtectedRoute><EmployeeHolidays /></ProtectedRoute>} />
        <Route path="/employee/payslips" element={<ProtectedRoute><EmployeePayslips /></ProtectedRoute>} />
        <Route path="/employee/team-requests" element={<ProtectedRoute roles={['Manager', 'Admin', 'Super Admin', 'HR']}><TeamRequests /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
